import * as React from 'react';
import { style } from './style';
import { useTheme } from '../Theme/Theme';
import { classes } from '../../helpers';
export const TabHeader = (props) => {
    const [inkStyle, setInkStyle] = React.useState({ left: 0, width: 0 });
    const className = 'hello' + Math.random().toString().slice(4, 7);
    const onContainerClick = (target) => {
        if (!target) {
            return;
        }
        const left = target.offsetLeft;
        const width = target.getBoundingClientRect().width;
        if (![].find.call(target.classList, (v) => v.includes(className))) {
            return;
        }
        if (left === inkStyle.left && width === inkStyle.width) {
            return;
        }
        setInkStyle({ left, width });
    };
    React.useEffect(() => {
        inkStyle.left === 0 && inkStyle.width === 0 && onContainerClick(document.body.querySelector(`.${className}0`));
        return () => {
        };
    });
    const theme = useTheme();
    const css = style(theme);
    return (React.createElement("div", { className: css.tabHeaderContainer, onClick: (e) => onContainerClick(e.target) },
        React.createElement("div", { className: css.inkBar, style: Object.assign(Object.assign({}, inkStyle), { bottom: '0' }) }),
        props.titles.map((v, i) => (React.createElement("div", { key: v.key, className: classes(`${className}${i}`, css.tabHeader), style: {
                color: v.key === props.activeKey && theme.primary,
            }, onClick: () => props.onClick(v.key) }, v.title)))));
};
//# sourceMappingURL=TabHeader.js.map